import {createAction, createReducer} from '@reduxjs/toolkit';

export const initialState = {
    isLoading: false,
};

type CheckoutType = typeof initialState;

export const setCheckoutLoading = createAction<boolean>('CHECKOUT@SET_CHECKOUT_LOADING');
export const resaveDelivery = createAction('CHECKOUT@RESAVE_DELIVERY');

/**
 * Checkout
 */
export const checkout = createReducer<CheckoutType>(initialState, builder => {
    builder.addCase(setCheckoutLoading, (state, {payload}) => ({
        ...state,
        isLoading: payload,
    }));
});
